if (!customElements.get("m-featured-slider")) {
  class MFeaturedSlider extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        sliderContainer: ".m-featured-slider__products",
        slideImages: ["m-featured-slider__img"],
        slideImagesContainer: ".m-featured-slider__images",
        sliderControls: ".m-slider-controls",
        prevBtn: ".m-slider-controls__button-prev",
        nextBtn: ".m-slider-controls__button-next",
      };
      this.domNodes = queryDomNodes(this.selectors, this);
    }

    connectedCallback() {
      this.initSlider();
    }

    updateScrollbar(activeIndex, totalSlides) {
  if (!this.scrollbarDrag || !this.scrollbarTrack) return;
  const trackWidth = this.scrollbarTrack.offsetWidth;
  const dragWidth = trackWidth / totalSlides;
  this.scrollbarDrag.style.width = `${dragWidth}px`;
  this.scrollbarDrag.style.transition = "transform 0.4s ease"; // 👈
  this.scrollbarDrag.style.transform = `translateX(${activeIndex * dragWidth}px)`;
}

    initSlider() {
      const showNavigation = this.dataset.showNavigation === "true";
      const showPagination = this.dataset.showPagination === "true";
      const paginationType = this.dataset.paginationType || "bullets";
      const autoplay = this.dataset.autoplay === "true";
      const timeout = this.dataset.timeout;

      let paginationConfig = false;

      if (paginationType === "scrollbar") {
        const scrollbarEl = this.querySelector(".swiper-scrollbar");
        const swiperContainer = this.domNodes.sliderContainer;

        if (scrollbarEl && swiperContainer) {
  swiperContainer.appendChild(scrollbarEl);
}

this.scrollbarTrack = swiperContainer.querySelector(".swiper-scrollbar");

if (this.scrollbarTrack) {
  let drag = this.scrollbarTrack.querySelector(".swiper-scrollbar-drag");
  if (!drag) {
    drag = document.createElement("div");
    drag.classList.add("swiper-scrollbar-drag");
    this.scrollbarTrack.appendChild(drag);
  }
  this.scrollbarDrag = drag;
}

      } else if (showPagination) {
        paginationConfig = {
          el: this.querySelector(".swiper-pagination"),
          type: "bullets",
          clickable: true,
        };
      }

      this.slider = new MinimogLibs.Swiper(this.domNodes.sliderContainer, {
        speed: 400,
        loop: false,
        autoplay: autoplay
          ? {
              delay: parseInt(timeout),
              disableOnInteraction: false,
            }
          : false,
        pagination: paginationConfig,
        on: {
          init: (swiper) => {
            if (paginationType === "scrollbar") {
              this.scrollbarDrag.style.transition = "none"; 
              this.updateScrollbar(0, swiper.slides.length);
            }

            if (showNavigation) {
              if (this.domNodes.prevBtn) this.domNodes.prevBtn.addEventListener("click", () => this.slider.slidePrev());
              if (this.domNodes.nextBtn) this.domNodes.nextBtn.addEventListener("click", () => this.slider.slideNext());
            }
          },
          slideChange: (swiper) => {
            if (paginationType === "scrollbar") {
              this.updateScrollbar(swiper.activeIndex, swiper.slides.length);
            }
          },
        },
      });

      // Sync 2 sliders
      this.imageSlider = new MinimogLibs.Swiper(this.domNodes.slideImagesContainer, {
        speed: 500,
        loop: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      });

      this.slider.on("activeIndexChange", (swiper) => {
        const { activeIndex } = swiper;
        this.imageSlider.slideTo(activeIndex);
      });

      this.imageSlider.on("activeIndexChange", (swiper) => {
        const { activeIndex } = swiper;
        this.slider.slideTo(activeIndex);
      });

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    onBlockSelect(evt) {
      const block = evt.target;
      const index = Number(block.dataset.index);
      if (this.slider) this.slider.slideToLoop(index);
      if (this.imageSlider) this.imageSlider.slideToLoop(index);
    }
  }

  customElements.define("m-featured-slider", MFeaturedSlider);
}